import { Heart, MessageCircle, Share2 } from 'lucide-react';
import { SiTiktok } from 'react-icons/si';
import { PreviewCardShell } from './PreviewCardShell';

interface TikTokVideoMockupProps {
  hook?: string;
  caption?: string;
  duration?: string;
  views?: string;
  likes?: string;
  comments?: string;
  shares?: string;
  username?: string;
  previewLabel?: string;
  hideShell?: boolean;
}

export const TikTokVideoMockup = ({
  hook = 'Video hook text...',
  caption = 'Video caption #hashtag',
  duration = '0:00',
  views = '0',
  likes = '0',
  comments = '0',
  shares = '0',
  username = '@username',
  previewLabel = 'TikTok Video Preview',
  hideShell = false,
}: TikTokVideoMockupProps) => {
  const content = (
    <div className="relative bg-gradient-to-br from-zinc-800 to-zinc-900" style={{ aspectRatio: '9/16' }}>
        {/* Hook text at top */}
        <div className="absolute top-4 left-4 right-16 z-10">
          <p className="text-white text-lg font-bold drop-shadow-lg line-clamp-2">{hook}</p>
        </div>

        {/* Duration badge */}
        <div className="absolute bottom-20 right-4 bg-black/70 text-white text-xs px-2 py-0.5 rounded">
          {duration}
        </div>

        {/* Right sidebar actions */}
        <div className="absolute right-2 bottom-24 flex flex-col gap-4 items-center">
          <div className="flex flex-col items-center">
            <div className="w-10 h-10 rounded-full bg-zinc-700 flex items-center justify-center mb-1">
              <Heart className="w-5 h-5 text-white" />
            </div>
            <span className="text-white text-xs font-semibold">{likes}</span>
          </div>
          <div className="flex flex-col items-center">
            <div className="w-10 h-10 rounded-full bg-zinc-700 flex items-center justify-center mb-1">
              <MessageCircle className="w-5 h-5 text-white" />
            </div>
            <span className="text-white text-xs font-semibold">{comments}</span>
          </div>
          <div className="flex flex-col items-center">
            <div className="w-10 h-10 rounded-full bg-zinc-700 flex items-center justify-center mb-1">
              <Share2 className="w-5 h-5 text-white" />
            </div>
            <span className="text-white text-xs font-semibold">{shares}</span>
          </div>
        </div>

        {/* Bottom caption area */}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4 pt-8">
          <div className="flex items-center gap-2 mb-2">
            <div className="w-8 h-8 rounded-full bg-gradient-to-br from-pink-400 to-purple-500" />
            <span className="text-white font-semibold text-sm">{username}</span>
          </div>
          <p className="text-white text-sm line-clamp-2">{caption}</p>
          <div className="text-zinc-300 text-xs mt-1">{views} views</div>
        </div>
    </div>
  );

  if (hideShell) {
    return content;
  }

  return (
    <PreviewCardShell
      className="mx-auto mb-3 w-full max-w-sm"
      badgeClassName="bg-gradient-to-r from-[#00f2ea] to-[#ff0050]"
      badge={<SiTiktok className="h-4 w-4 text-white" />}
      label={previewLabel}
    >
      {content}
    </PreviewCardShell>
  );
};
